module.exports = __webpack_public_path__ + "static/media/main.e485dc6e.scss";


//////////////////
// WEBPACK FOOTER
// ./src/style/scss/custom/main.scss
// module id = 15
// module chunks = 0